import { forwardRef } from 'react';
import { DOCUMENTATION_FONT_OPTIONS } from './documentationFontOptions';

type DocumentationEditorToolbarProps = {
  toolbarPinned?: boolean;
  onTogglePin?: () => void;
};

/** Toolbar HTML do Quill (documentação) — botões com ícones visíveis. */
export const DocumentationEditorToolbar = forwardRef<HTMLDivElement, DocumentationEditorToolbarProps>(
  function DocumentationEditorToolbar({ toolbarPinned = false, onTogglePin }, ref) {
    return (
      <div ref={ref} className="rte-docs-toolbar ql-toolbar ql-snow">
        <span className="ql-formats">
          <select className="ql-header" defaultValue="" title="Estilo">
            <option value="1">Título 1</option>
            <option value="2">Título 2</option>
            <option value="3">Título 3</option>
            <option value="">Normal</option>
          </select>
          <select className="ql-font" defaultValue="arial" title="Fonte">
            {DOCUMENTATION_FONT_OPTIONS.map((font) => (
              <option key={font.value} value={font.value}>
                {font.label}
              </option>
            ))}
          </select>
          <select className="ql-size" defaultValue="16px" title="Tamanho">
            <option value="12px">12</option>
            <option value="14px">14</option>
            <option value="16px">16</option>
            <option value="18px">18</option>
            <option value="24px">24</option>
            <option value="32px">32</option>
          </select>
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-bold" title="Negrito" />
          <button type="button" className="ql-italic" title="Itálico" />
          <button type="button" className="ql-underline" title="Sublinhado" />
          <button type="button" className="ql-strike" title="Tachado" />
        </span>

        <span className="ql-formats">
          <select className="ql-color" title="Cor do texto" />
          <select className="ql-background" title="Destaque" />
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-list" value="ordered" title="Lista numerada" />
          <button type="button" className="ql-list" value="bullet" title="Lista com marcadores" />
          <button type="button" className="ql-list" value="check" title="Lista de verificação" />
          <button type="button" className="ql-indent" value="-1" title="Diminuir recuo" />
          <button type="button" className="ql-indent" value="+1" title="Aumentar recuo" />
        </span>

        <span className="ql-formats">
          <select className="ql-align" title="Alinhamento" />
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-blockquote" title="Citação" />
          <button type="button" className="ql-code-block" title="Código" />
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-link" title="Link" />
          <button type="button" className="ql-image" title="Imagem" />
          <button type="button" className="ql-video" title="Vídeo" />
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-divider" title="Linha horizontal">
            <svg viewBox="0 0 18 18" aria-hidden="true">
              <line className="ql-stroke" x1="3" x2="15" y1="9" y2="9" />
            </svg>
          </button>
          <button type="button" className="ql-callout" title="Seção colorida">
            <svg viewBox="0 0 18 18" aria-hidden="true">
              <rect className="ql-stroke" x="3" y="3" width="12" height="12" rx="2" fill="none" />
              <rect className="ql-fill" x="5" y="5" width="8" height="3" rx="0.5" />
            </svg>
          </button>
          <button type="button" className="ql-collapse" title="Seção expansível">
            <svg viewBox="0 0 18 18" aria-hidden="true">
              <rect className="ql-stroke" x="3" y="3" width="12" height="12" rx="2" fill="none" />
              <polyline className="ql-stroke" points="6 8 9 11 12 8" fill="none" />
            </svg>
          </button>
          <button type="button" className="ql-table" title="Tabela">
            <svg viewBox="0 0 18 18" aria-hidden="true">
              <rect className="ql-stroke" x="3" y="3" width="12" height="12" fill="none" />
              <line className="ql-stroke" x1="3" x2="15" y1="8" y2="8" />
              <line className="ql-stroke" x1="3" x2="15" y1="13" y2="13" />
              <line className="ql-stroke" x1="8" x2="8" y1="3" y2="15" />
            </svg>
          </button>
          <button type="button" className="ql-emoji" title="Emoji">
            <svg viewBox="0 0 18 18" aria-hidden="true">
              <circle className="ql-stroke" cx="9" cy="9" r="6" fill="none" />
              <circle className="ql-fill" cx="6.5" cy="7.5" r="0.9" />
              <circle className="ql-fill" cx="11.5" cy="7.5" r="0.9" />
              <path className="ql-stroke" d="M6.5 11.2c.8 1 1.7 1.4 2.5 1.4s1.7-.4 2.5-1.4" fill="none" />
            </svg>
          </button>
        </span>

        <span className="ql-formats">
          <button type="button" className="ql-clean" title="Limpar formatação" />
        </span>

        {onTogglePin ? (
          <span className="ql-formats rte-toolbar-pin-wrap">
            <button
              type="button"
              className={`rte-toolbar-pin${toolbarPinned ? ' is-pinned' : ''}`}
              title={toolbarPinned ? 'Desafixar barra' : 'Fixar barra'}
              aria-label={toolbarPinned ? 'Desafixar barra de ferramentas' : 'Fixar barra de ferramentas'}
              aria-pressed={toolbarPinned}
              onMouseDown={(e) => e.preventDefault()}
              onClick={onTogglePin}
            >
              <span className="rte-toolbar-pin__emoji" aria-hidden>
                📌
              </span>
            </button>
          </span>
        ) : null}
      </div>
    );
  },
);
